import { Box, Typography } from '@mui/material';
import { downloadInvoiceIconSrc } from '../../assets/transactions';

/** Figma 11114:38497 — Download Invoice pill button */
export default function DownloadInvoiceButton({
  onClick,
  disabled = false,
  disabledTitle = 'Invoice will be generated shortly',
}) {
  return (
    <Box
      component="button"
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-label="Download Invoice"
      aria-disabled={disabled}
      title={disabled ? disabledTitle : undefined}
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        height: 32,
        px: '8px',
        py: '5px',
        border: 0,
        borderRadius: '100px',
        bgcolor: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        overflow: 'hidden',
        boxShadow: 'inset 0 0 4px rgba(0, 0, 0, 0.65)',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          bgcolor: 'rgba(0, 0, 0, 0.54)',
          pointerEvents: 'none',
        },
      }}
    >
      <Box
        component="img"
        src={downloadInvoiceIconSrc}
        alt=""
        sx={{
          position: 'relative',
          zIndex: 1,
          width: 18,
          height: 18,
          display: 'block',
          flexShrink: 0,
          opacity: disabled ? 0.35 : 1,
          filter: disabled ? 'grayscale(1)' : 'none',
        }}
      />
      <Typography
        sx={{
          position: 'relative',
          zIndex: 1,
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          fontSize: 12,
          lineHeight: '22px',
          letterSpacing: 0,
          color: '#ff00f2',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          opacity: disabled ? 0.35 : 1,
        }}
      >
        Download Invoice
      </Typography>
    </Box>
  );
}
